<template>
  <el-dialog
      :title="$t('text.batchEditMerchant')"
      :visible="show"
      @close="closeDialog"
      @open="init"
      :close-on-click-modal="false"
  >
    <el-form :model="form" ref="form">
      <el-row>
        <el-col :span="8">
          <el-form-item
              :label="$t('text.collectionStatus')"
              :label-width="formLabelWidth"
              prop="depositStatus">

              <el-select v-model="form.depositStatus" :value=null>
                <el-option :label="$t('collectionStatus.00')"
                           value="00"></el-option>
                <el-option :label="$t('collectionStatus.01')"
                           value="01"></el-option>
                <el-option :label="$t('option.unchanged')"
                           :value=null></el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
              :label="$t('text.disbursementStatus')"
              :label-width="formLabelWidth"
              prop="withdrawStatus">
              <el-select v-model="form.withdrawStatus" :value=null>
                <el-option :label="$t('disbursementStatus.00')"
                           value="00"></el-option>
                <el-option :label="$t('disbursementStatus.01')"
                           value="01"></el-option>
                <el-option :label="$t('option.unchanged')"
                           :value=null></el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item v-if="ROLE_TYPE.isManager()"
              :label="$t('text.settlementCycle')"
              :label-width="formLabelWidth"
              prop="settlementCycle">
              <el-select v-model="form.settlementCycle" :value=null>
                <el-option :label="$t('settlementCycle.D0')"
                           value="D0"></el-option>
                <el-option :label="$t('settlementCycle.T1')"
                           value="T1"></el-option>
                <el-option :label="$t('settlementCycle.D0T1')"
                           value="D0T1"></el-option>
                <el-option :label="$t('settlementCycle.T2')"
                           value="T2"></el-option>
                <el-option :label="$t('option.unchanged')"
                           :value=null></el-option>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item
              :label="$t('text.bdName')"
              :label-width="formLabelWidth"
              prop="bdName"
          >
            <el-input
                v-model="form.bdName"
                :placeholder="$t('option.unchanged')"
                clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item
              :label="$t('text.payoutMinAmount')"
              :label-width="formLabelWidth"
              prop="withdrawMinAmount"
          >
            <el-input
                v-model="form.withdrawMinAmount"
                @input="(val) => handleInput(val, 'withdrawMinAmount')"
                :placeholder="$t('message.inputMinTransactionAmount')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
              :label="$t('text.payoutMaxAmount')"
              :label-width="formLabelWidth"
              prop="withdrawMaxAmount"
          >
            <el-input
                v-model="form.withdrawMaxAmount"
                @input="(val) => handleInput(val, 'withdrawMaxAmount')"
                :placeholder="$t('message.inputMaxTransactionAmount')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
              :label="$t('text.payoutNotifyAmount')"
              :label-width="formLabelWidth"
              prop="withdrawTelegramNotifyAmount"
          >
            <el-input
                v-model="form.withdrawTelegramNotifyAmount"
                @input="(val) => handleInput(val, 'withdrawTelegramNotifyAmount')"
                :placeholder="$t('message.inputNotifyTransactionAmount')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8" v-for="(value, key) in PaymentType[this.country].PAYMENT" :key="`payment_${key}`">
          <el-form-item
              :label="$t(`text.collection${key}FeeRate`)"
              :label-width="formLabelWidth"
              :prop="`paymentRateConfig.${value}`"
          >
            <el-input
                v-model="form.paymentRateConfig[value]"
                :placeholder="$t('message.inputCollectionFeeRate')"
                @input="handleInput($event, `paymentRateConfig.${value}`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8" v-for="(value, key) in PaymentType[this.country].TRANSFER" :key="`transfer_${key}`">
          <el-form-item
              :label="$t(`text.disbursement${key}FeeRate`)"
              :label-width="formLabelWidth"
              :prop="`transferRateConfig.${value}`">
            <el-input
                v-model="form.transferRateConfig[value]"
                :placeholder="$t('message.inputDisbursementFeeRate')"
                @input="handleInput($event, `transferRateConfig.${value}`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item
              :label="$t(`text.merchant.risk.minute`)"
              :label-width="formLabelWidth"
              :prop="`riskConfig.minute`"
          >
            <el-input
                v-model="form.riskConfig.minute"
                :placeholder="$t('message.inputMinute')"
                @input="(val) => handleInput(val, `riskConfig.minute`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              :label="$t(`text.merchant.risk.times`)"
              :label-width="formLabelWidth"
              :prop="`riskConfig.times`"
          >
            <el-input
                v-model="form.riskConfig.times"
                :placeholder="$t('message.inputTimes')"
                @input="(val) => handleInput(val, `riskConfig.times`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item
              :label="$t(`text.merchant.risk.dailyMaxAmount`)"
              :label-width="formLabelWidth"
              :prop="`riskConfig.dailyMaxAmount`"
          >
            <el-input
                v-model="form.riskConfig.dailyMaxAmount"
                :placeholder="$t('message.inputAmount')"
                @input="(val) => handleInput(val, `riskConfig.dailyMaxAmount`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              :label="$t(`text.merchant.risk.dailyMaxCount`)"
              :label-width="formLabelWidth"
              :prop="`riskConfig.dailyMaxCount`"
          >
            <el-input
                v-model="form.riskConfig.dailyMaxCount"
                :placeholder="$t('message.inputTimes')"
                @input="(val) => handleInput(val, `riskConfig.dailyMaxCount`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit" v-if="isButton">{{ $t('text.confirm') }}</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {ROLE_TYPE} from "@/utils/Constant";
import { PaymentType, getEmptyConfig } from '@/constants/paymentTypes';

export default {
  name: "merchantEdit",
  props: {
    show: Boolean,
    value: Array,
    action: String
  },
  data() {
    return {
      dialogShow: this.show,
      country: this.$store.state.isPK ? 'PK' : 'BD',
      isButton: true,
      isDisabled: false,
      form: {
        depositStatus: null,
        withdrawStatus: null,
        settlementCycle: null,
        bdName: null,
        withdrawMinAmount: null,
        withdrawMaxAmount: null,
        withdrawTelegramNotifyAmount: null,
        paymentRateConfig: getEmptyConfig(this.$store.state.isPK ? 'PK' : 'BD', 'PAYMENT'),
        transferRateConfig: getEmptyConfig(this.$store.state.isPK ? 'PK' : 'BD', 'TRANSFER'),
        riskConfig: this.getEmptyRiskConfig(),
      },
      formLabelWidth: "130px",
      PaymentType
    };
  },
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    },
    productId() {
      return this.action.replace("batch_", "");
    }
  },
  methods: {
    init() {
    },
    handleInput(val, type) {
      val = val.replace(/[^\d.]/g, ""); // 清除"数字"和"."以外的字符
      val = val.replace(/\.{2,}/g, "."); // 只保留第一个. 清除多余的
      val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      val = val.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
      if (val.indexOf(".") < 0 && val !== "" && !type.includes("RateConfig")) {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        val = parseFloat(val);
      }
      if (type.includes('.')) {
        const [obj, key] = type.split('.');
        this.form[obj][key] = val;
      } else {
        this.form[type] = val;
      }
      this.$forceUpdate();
    },
    getEmptyRiskConfig(){
      let config = {};
      config.minute = '';
      config.times = '';
      config.dailyMaxAmount = '';
      config.dailyMaxCount = '';
      return config;
    },
    closeDialog() {
      this.$refs["form"].clearValidate();

      this.form = {
        depositStatus: null,
        withdrawStatus: null,
        settlementCycle: null,
        bdName: null,
        withdrawMinAmount: null,
        withdrawMaxAmount: null,
        withdrawTelegramNotifyAmount: null,
        paymentRateConfig: getEmptyConfig(this.country, 'PAYMENT'),
        transferRateConfig: getEmptyConfig(this.country, 'TRANSFER'),
        riskConfig: this.getEmptyRiskConfig(),
      };

      this.$emit("update:show", false)
    },
    submit() {
      console.log(this.form);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // Filter out empty values before converting to JSON
          const filteredPaymentConfig = Object.fromEntries(
            Object.entries(this.form.paymentRateConfig).filter(([_, value]) => value !== '' && value !== null)
          );
          const filteredTransferConfig = Object.fromEntries(
            Object.entries(this.form.transferRateConfig).filter(([_, value]) => value !== '' && value !== null)
          );
          const riskConfig = {
            ...this.getEmptyRiskConfig(),
            ...this.form.riskConfig
          };
          this.form.paymentRateConfig = JSON.stringify(filteredPaymentConfig);
          this.form.transferRateConfig = JSON.stringify(filteredTransferConfig);
          this.form.riskConfig = JSON.stringify(riskConfig);

          let params = {
            ...this.form,
            appIds: this.value.join(",")
          }

          this.axios
              .post("/merchant/merchantInfoUpdateBatch", params)
              .then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                    type: "success"
                  });

                  this.$bus.$emit("refresh"); //通知刷新

                  this.closeDialog();
                } else {
                  this.$notify.error({
                    title: this.$t('text.prompt'),
                    message: res.msg
                  });
                }
              });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
